import { FinanceBulkImportController } from './financeBulkImport.controller';
import template from './financeBulkImport.html';

export const financeBulkImportComponent = {
  name: 'financeBulkImport',
  restrict: 'E',
  controller: FinanceBulkImportController,
  controllerAs: 'vm',
  template,
  bindings: {
    label: '@',
    type: '@',
    onImport: '&'
  }
};
